export const B2C_ENABLED_HOSTNAMES = ['app.revers.io'];

export const isUsingB2c = () => {
  if (window?.location?.hostname === 'localhost') {
    return false;
  }

  return B2C_ENABLED_HOSTNAMES.includes(
    typeof window !== 'undefined' ? window.location.hostname : '',
  );
};
